import type { IconSvgObject } from './types';

const WeightIcon: IconSvgObject = [
  ["path", { d: "M12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.5119 9H7.48806C6.60484 9 5.8262 9.57934 5.57241 10.4253L3.07355 18.7548C3.02478 18.9174 3 19.0862 3 19.256C3 20.2192 3.78083 21 4.74403 21H19.256C20.2192 21 21 20.2192 21 19.256C21 19.0862 20.9752 18.9174 20.9264 18.7548L18.4276 10.4253C18.1738 9.57934 17.3952 9 16.5119 9Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default WeightIcon;
